// TODO review this alone function
export const getPageDataPath = path => {
  const fixedPagePath = path === `/` ? `index` : path;
  return `page-data/${fixedPagePath}/page-data.json`.replaceAll(/\/{2,}/g, '/');
};
